module.exports = __webpack_public_path__ + "docs/t&c.7da592059379e3471d4848571adc8378.html";